module.exports = __webpack_public_path__ + "static/media/pit2.bcf25df8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pioricost-fruit/pitahaya/pit2.jpeg
// module id = 43
// module chunks = 0